import * as stylex from "@stylexjs/stylex";
import React from "react";
import { typography } from "../../../materials/typography.stylex";
import { lineChartDefaultStyles as styles } from "./styles";
const TICK_HEIGHT = 4;
const XTick = React.memo(({ textAnchor, label, transform })=><g transform={transform}>
      <line {...stylex.props(styles.axisXLine)} y2={TICK_HEIGHT}/>
      <text {...stylex.props(typography.axis, styles.axisLabel)} y={TICK_HEIGHT + 5} dy="0.6em" textAnchor={textAnchor}>
        {label}
      </text>
    </g>);
export default XTick;
